import { POTENTIAL_APP_CRASH_KEY } from 'constant';
import { logger } from 'services';

export const unreachable = (any: never): any => {
  if (process.env.NODE_ENV === 'production') {
    logger.error(`${POTENTIAL_APP_CRASH_KEY}: cannot be reached`, {
      error: any,
    });
  } else {
    throw new Error(`cannot be reached ${JSON.stringify(any)}`);
  }
};
